module.exports = __webpack_public_path__ + "img/x.56131b82.svg";